document.addEventListener("alpine:init", () => {
  Alpine.store("collection", {
    grid: typeof window !== 'undefined' && window.innerWidth >= 1024 ? 'small' : 'medium',
    isFacetsOpen: false,
    setGrid(grid) {
      this.grid = grid;
      window.dispatchEvent(new CustomEvent('collection:grid-changed'));
    }
  });
  
  Alpine.store('modals', {
    openModalId: null
  });
});
